module.exports = "pegasus/assets/basic-image-text-header-preview.png";